import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex--justify-space-between mb-24" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex--gap-large flex--align-center" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "h1" }, " Settings ")
  ])
], -1 /* HOISTED */)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TabNavigationComponent = _resolveComponent("TabNavigationComponent")
  const _component_PageLoaderComponent = _resolveComponent("PageLoaderComponent")
  const _component_ProfileFormComponent = _resolveComponent("ProfileFormComponent")
  const _component_NotificationSettingsComponent = _resolveComponent("NotificationSettingsComponent")
  const _component_PasswordFormComponent = _resolveComponent("PasswordFormComponent")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_2,
          _createVNode(_component_TabNavigationComponent, {
            tabs: $options.tabs,
            "active-tab": $data.active_tab,
            onSetTab: $options.setRoute
          }, null, 8 /* PROPS */, ["tabs", "active-tab", "onSetTab"]),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              ($data.loading_tab)
                ? (_openBlock(), _createBlock(_component_PageLoaderComponent, { key: 0 }))
                : ($data.active_tab === 'profile')
                  ? (_openBlock(), _createBlock(_component_ProfileFormComponent, { key: 1 }))
                  : ($data.active_tab === 'notifications')
                    ? (_openBlock(), _createBlock(_component_NotificationSettingsComponent, { key: 2 }))
                    : ($data.active_tab === 'password')
                      ? (_openBlock(), _createBlock(_component_PasswordFormComponent, { key: 3 }))
                      : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          })
        ])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}